module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/september-e7449c2b8a4d98f041a5b993e3507e6b.png";